import { NavLink } from "react-router-dom";
import { decryptData, Loading } from "../components/const";
import UseFetch from "../components/UseFetch";
import $ from "jquery"
import { useRef, useState } from "react";
import ModalAvanceFournisseur from "../Comptability/ModalAvanceFournisseur";
const Fournisseurs = () => {
    const { data: fournisseurs, isloading } = UseFetch('fournisseurs/liste');
    const user = decryptData('USER');
    const tableRef = useRef(null)
    const [selectedFourn, setSelectedFour] = useState(null)
    $(tableRef.current).DataTable()

    return (
        <div className="Fournsisseur">
            <div className="row my-2">
                <div className="col-lg-6 h2 text-primary">
                    LISTE DES FOURNISSEURS
                </div>

            </div>
            {
                isloading ? <Loading /> : fournisseurs?.length ?
                    <div className="row">
                        <div className="table-responsive p-2">
                            <table ref={tableRef} className="table table-hover table-striped table-bordered border-primary nowrap">
                                <thead className="table-dark border-primary">
                                    <tr>
                                        <td>N°</td>
                                        <td>PRENOMS ET NOM</td>
                                        <td>TELEPHONE</td>
                                        <td>ADRESSE</td>
                                        <td>DATE AJOUT</td>
                                        <td className="text-end">ACTIONS</td>
                                    </tr>

                                </thead>
                                <tbody className="plage">
                                    {
                                        fournisseurs.map((fourn, index) => (
                                            <tr key={index} className="tr">
                                                <td>{index + 1}</td>
                                                <td className="fourn">{`${fourn.prenoms} ${fourn.nom}`}</td>
                                                <td>{fourn.telephone}</td>
                                                <td>{fourn.adresse}</td>
                                                <td>{new Date(fourn.created_at).toLocaleDateString()}</td>
                                                <td className="text-end">
                                                    {user.droit == 'Comptable' && <button className="btn btn-success m-1" data-bs-toggle="modal" data-bs-target="#modal-avance-fourn" onClick={() => setSelectedFour(fourn)}>Avance</button>}
                                                    <NavLink className="btn btn-primary m-1" to='/compte-fournisseur' state={{ fourn }}>
                                                        Voir compte
                                                        {/* <i className="bx bx-show"></i> */}
                                                    </NavLink>

                                                </td>
                                            </tr>
                                        ))
                                    }

                                </tbody>
                            </table>
                        </div>

                    </div>

                    :
                    <div className="row justify-content-center p-2 bg-danger-subtle text-danger fs-3 fs-5">Aucun fournisseur trouvé!</div>
            }
            <ModalAvanceFournisseur fournisseur={selectedFourn} />
        </div>
    );
}

export default Fournisseurs;